<script lang="ts">
	import { Fa } from 'svelte-fa';
	import * as icons from '@fortawesome/free-solid-svg-icons';
	import type { IconDefinition } from '@fortawesome/fontawesome-common-types';

	type IconSize =
		| 'xs'
		| 'sm'
		| 'lg'
		| '1x'
		| '2x'
		| '3x'
		| '4x'
		| '5x'
		| '6x'
		| '7x'
		| '8x'
		| '9x'
		| '10x'
		| `${number}x`;

	type FlipDir = 'horizontal' | 'vertical' | 'both';
	type PullDir = 'left' | 'right';

	type FaProps = {
		class?: string | undefined;
		id?: string | undefined;
		style?: string | undefined;
		title?: string | undefined;
		size?: IconSize | undefined;
		color?: string | undefined;
		fw?: boolean | undefined;
		pull?: PullDir | undefined;
		scale?: string | number | undefined;
		translateX?: string | number | undefined;
		translateY?: string | number | undefined;
		rotate?: number | string | undefined;
		flip?: FlipDir | undefined;
		spin?: boolean | undefined;
		pulse?: boolean | undefined;
		primaryColor?: string | undefined;
		secondaryColor?: string | undefined;
		primaryOpacity?: string | number | undefined;
		secondaryOpacity?: string | number | undefined;
		swapOpacity?: boolean | undefined;
	};

	let { name, ...props }: { name: string } & FaProps = $props();
</script>

<Fa icon={icons[name as keyof typeof icons] as IconDefinition} {...props} />
